import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationState } from '../../store/application-store';
import { select, Store } from '@ngrx/store';
import * as widgetGalleryActions from '../actions/widget-gallery.actions';
import { take } from 'rxjs';

@Injectable()
export class WidgetGalleryService {

  constructor(private readonly store: Store<ApplicationState>) { }

  openGallery(): void {
    this.store.dispatch(new widgetGalleryActions.Open());
  }

  closeGallery(): void {
    this.store.dispatch(new widgetGalleryActions.Close());
  }

  isGalleryOpen(): Observable<boolean> {
    return this.store.pipe(select((state) => state.widgetGallery.open));
  }

  toggle(): void {
    this.isGalleryOpen().pipe(
      take(1)
    ).subscribe((isOpen) => {
      if (isOpen) {
        this.closeGallery();
      } else {
        this.openGallery();
      }
    });
  }
}
